import { updateDoc, doc } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebaseConfig";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import FileResizer from "react-image-file-resizer";

function CollegesEdit(props) {
  const [selectedFile, setSelectedFile] = useState();
  const [preview, setPreview] = useState(props.office.logoUrl || "");
  const [name, setName] = useState(props.office.name);
  const [shortName, setShortName] = useState(props.office.shortName);
  const [idOffice, setIdOffice] = useState(props.office.idOffice);
  const [uploadProgress, setUploadProgress] = useState(0);
  let url;

  useEffect(() => {
    if (!selectedFile) {
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const saveEdit = async (id) => {
    const officesDoc = doc(db, "offices", id);
    const officesInput = {
      name: name,
      shortName: shortName,
      idOffice: idOffice,
      logoUrl: url,
    };
    await updateDoc(officesDoc, officesInput);
    props.refresh();
    alert("College Updated");
    props.close();
  };

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    setSelectedFile(e.target.files[0]);
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      FileResizer.imageFileResizer(
        file,
        300,
        300,
        "PNG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  const uploadFile = (file) => {
    const storageRef = ref(storage, `/files/images/${shortName}.png`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setUploadProgress(prog);
        if (prog === 100) {
          getDownloadURL(storageRef)
            .then((res) => {
              url = res;
            })
            .then(() => {
              saveEdit(props.office.id);
            });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const formHandler = async (e) => {
    try {
      e.preventDefault();
      let file = e.target[0].files[0];
      if (!file) {
        saveEdit(props.office.id);
      } else {
        const image = await resizeFile(file);
        uploadFile(image);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-slate-800 opacity-50" onClick={props.close} />
      <div className="relative z-10 w-full max-w-lg mx-4 bg-white rounded-2xl shadow-2xl overflow-y-auto max-h-[90vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-slate-100">
          <div>
            <h2 className="text-xl font-bold text-slate-800">Edit College</h2>
            <p className="text-sm text-slate-400 mt-0.5">Update college office details</p>
          </div>
          <button
            className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
            onClick={props.close}
            aria-label="Close"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Form */}
        <form className="flex flex-col gap-5 px-6 py-5" onSubmit={formHandler}>
          {/* Logo section */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide">Logo</p>
            <label className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-slate-300 rounded-xl cursor-pointer hover:border-sky-400 hover:bg-sky-50 transition-colors overflow-hidden">
              {preview ? (
                <img className="h-full w-full object-contain" src={preview} alt="Logo preview" />
              ) : (
                <div className="flex flex-col items-center gap-2 text-slate-400">
                  <svg className="h-10 w-10" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                  </svg>
                  <span className="text-sm font-medium">Click to replace logo</span>
                  <span className="text-xs">PNG, JPG up to 300×300</span>
                </div>
              )}
              <input
                className="hidden"
                type="file"
                accept="image/*"
                onChange={onSelectFile}
              />
            </label>
            {/* Progress bar */}
            <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden">
              <div
                className="h-1.5 bg-sky-500 rounded-full transition-all duration-300"
                style={{ width: `${uploadProgress}%` }}
              />
            </div>
            {uploadProgress > 0 && uploadProgress < 100 && (
              <p className="text-xs text-slate-400 text-right">{uploadProgress}% uploaded</p>
            )}
          </div>

          {/* Information section */}
          <div className="flex flex-col gap-4">
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide border-t border-slate-100 pt-4">Information</p>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-slate-600" htmlFor="ce-name">
                Office Name
              </label>
              <input
                id="ce-name"
                className="rounded-lg border border-slate-300 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 outline-none px-3 py-2 text-sm w-full transition-colors"
                type="text"
                placeholder="College of Information Technology and Engineering"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-slate-600" htmlFor="ce-short">
                Abbreviation
              </label>
              <input
                id="ce-short"
                className="rounded-lg border border-slate-300 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 outline-none px-3 py-2 text-sm w-full transition-colors"
                type="text"
                placeholder="CITE"
                onChange={(e) => setShortName(e.target.value)}
                value={shortName}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-slate-600" htmlFor="ce-order">
                Number Order
              </label>
              <input
                id="ce-order"
                className="rounded-lg border border-slate-300 focus:border-sky-500 focus:ring-2 focus:ring-sky-200 outline-none px-3 py-2 text-sm w-full transition-colors"
                type="number"
                placeholder="0"
                onChange={(e) => setIdOffice(e.target.value)}
                value={idOffice}
              />
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-1">
            <button
              type="button"
              className="flex-1 py-2 rounded-lg border border-slate-300 text-sm font-semibold text-slate-600 hover:bg-slate-50 transition-colors"
              onClick={props.close}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 py-2 rounded-lg bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white text-sm font-semibold transition-colors shadow-sm"
            >
              Update College
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CollegesEdit;
